import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function useGender() {
  const { t } = useI18n()

  const genderMap = computed(() => ({
    1: t('address.gender.female'),
    2: t('address.gender.male'),
    3: t('address.gender.company'),
    4: t('address.gender.divers'),
  }))

  const genderOptions = computed(() =>
    Object.entries(genderMap.value).map(([value, label]) => ({
      value: Number(value),
      label,
    }))
  )
  
  const getGenderLabel = (value) => genderMap.value[value] || ''

  return {
    genderOptions,
    getGenderLabel,
  }
}
